
import { SectionWithListWithAssetPageSchema } from 'cms/schemaTypes/staticPages/documents/sectionListWithAsset'
import Image from 'next/image'

import { urlFor } from 'lib/sanity/image'
import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import FormattedText from 'shared/ui/FormattedText'

import { SectionContainer } from '../landings/styles'

import styles from './HowItWorks.module.scss'

interface HowItWorksProps {
  content: SectionWithListWithAssetPageSchema
}
const HowItWorks = ({ content }: HowItWorksProps) => {
  return (
    <SectionContainer $condensed className={styles.sectionContainer}>
      <section className={styles.contentWrapper}>
        <h2 className={styles.title}>
          <FormattedText text={content.header} />
        </h2>
        <div className={styles.itemsWrapper}>
          {content.sectionList.map(item => (
            <div key={item.key} className={styles.item}>
              <Image
                src={urlFor(item.image.asset.asset).url()}
                alt={item.image.alt}
                width={105}
                height={90}
              />
              <h3 className={styles.itemTitle}>
                <CustomPortableText value={item.content || []} />
              </h3>
            </div>
          ))}
        </div>
      </section>
    </SectionContainer>
  )
}

export default HowItWorks
